/** @module ProductSpec/SizeChart/SizeRangeSelectForm */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/widget/FormGroupSelection"
], function(declare,csi,_,FormWidget,html,locale,FormGroupSelection) {

	/**
	 * This module is an inner widget for first row of Size Chart -> Product Group selection view
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Size Range" tooltip "Edit"
	 * Outer view widget = ProductSpec/SizeChart/SizeRangeView.js
	 * Module = ProductSpec.xml
	 * View Id = "SizeRange" xsi:type="Html"
	 * Template = "ProductSpec/SizeChart/SizeRangeView.html"
	 * ControllerClass = "ProductSpec/SizeChart/SizeRangeView"
	 */

	const CSS_CLASS_RADIO_GROUP_DISABLED = "csi-field-group-container-disabled";

	return declare(FormWidget, {

		/**
		 * @override
		 * Create Sub Range selection widget
		 */
		onDrawSizeRange: function(defView, field, value, div, control, widgetParam) {
			const tr = this.getFieldRow(field);
			html.clear(tr);
			const td = html.create("td",{colspan: 3}, tr)
			const node = this.getCache().getNode(widgetParam.value);
			new FormGroupSelection({
				name: "picker",
				widgetUniqId: csi.getUniqueId(this.id),
				control: control,
				currentValueLabel: locale.resource("SizeRangeCurrent"),
				currentValue: node && node.$Name,
				currentAdditionalText: "",
				dropdownLabel: locale.resource("SizeRangeNew"),
				store: widgetParam.store,
				value: "",
				onChangeValue: function(value) {
					var htmlView = this.getParent().viewParent;
					htmlView.newSizeRange = value;
					htmlView.refreshSaveBtn();
				}
			}).placeAt(td);
		}

	});
});